import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppSettings } from '../../app.constant';
import { RoleService } from '../../shared/services/role.service';

@Component({
  selector: 'app-roles',
  templateUrl: './roles.component.html',
  styleUrls: ['./roles.component.css']
})
export class RolesComponent implements OnInit {

  PK_RoleID:string;
  RoleName:string;
  RoleDescription:string;
  
  roleForm:FormGroup;
  submitted=false;
  roles:any;
  post:any;
  errorMessage: String;
  constructor(private formBuilder:FormBuilder, private _roleService:RoleService,) { }

  ngOnInit() {
    this.roleForm = this.formBuilder.group({
      'PK_RoleID':['', Validators.required],
      'RoleName':['', Validators.required],
      'RoleDescription':['', Validators.required],
      })
  }

  getAllRole() :void  {
    // alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.loginForm.value))
      // this.post=JSON.stringify();
      // console.log(this.post);
       this._roleService.getAllRole(AppSettings.API_ENDPOINT+AppSettings.GetAllRole).subscribe(
      data =>
         {
           this.roles=data;
      },
      error => this.errorMessage = <any>error)
  }

  createRole(post) :void  {
    // alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.loginForm.value))
       this.post=JSON.stringify(post);
      // console.log(this.post);
       this._roleService.postRole(AppSettings.API_ENDPOINT+AppSettings.CreateRole,this.post).subscribe(
      data =>
         {
      },
      error => this.errorMessage = <any>error)
  }
}




